import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class RpoCalculationService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params));
            return {
                success: true,
                data: response.data,
                pagination: response.pagination || {},
                message: response.message
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch RPO calculations');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id));
            return {
                success: true,
                data: response.data,
                message: response.message
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch RPO calculation');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'RPO calculation created'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create RPO calculation');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'RPO calculation updated'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update RPO calculation');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return {
                success: true,
                message: response.message || 'RPO calculation deleted'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete RPO calculation');
        }
    }

    async batchDelete(ids) {
        try {
            const response = await this.api.batchDelete(ids);
            return {
                success: true,
                message: response.message || 'RPO calculations deleted successfully'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to batch delete RPO calculations');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        return new ApiError(error.message || defaultMessage, 500);
    }
}
